<template lang="pug">
.item.d-flex.flex-md-column.flex-lg-row
  img.flex-shrink-0(:src="item.img")
  .content.i_ml_6.i_ml_md_0.i_ml_sm_6.i_mt_md_4.i_mt_sm_0
    h5 {{ item.title }}
    p.i_body_l {{ item.content }}
    router-link(:to="item.pageUrl")
      .see_more_btn.float-right.float-md-none.float-lg-right 看更多
</template>

<script>
export default {
  name: "Item",
  props: {
    item: Object,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/about_us/social_responsibility/item";
</style>
